"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Bug = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 24,
  height: 24,
  viewBox: "2 2 20 22"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M20.804 10.02l.392 1.96-4.196.84V14h4v2h-4v1.181l4.196.84-.392 1.96-4.475-.896-3.622 3.623a1 1 0 0 1-1.414 0l-3.621-3.622-4.476.895-.392-1.96L7 17.18v-1.18H3v-2h4v-1.18l-4.196-.84.392-1.96 4.903.98h7.802l4.903-.98zm-5.636-7.574l1.664 1.11-1.285 1.926A4.981 4.981 0 0 1 17 9.002a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1c0-1.371.557-2.614 1.453-3.518L7.168 3.555l1.664-1.11 1.286 1.929A4.978 4.978 0 0 1 12 4a4.97 4.97 0 0 1 1.882.375l1.286-1.93z"
}));

var _default = Bug;
exports.default = _default;